import React, { useEffect } from 'react';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@spotahome/ui-library';

import MatcherIcon from '@common/components/MatcherModal/MatcherIcon';
import './Onboarding.scss';

const Onboarding = ({ next, close }) => {
  const handleClose = buttonType => {
    Metrics.ga.sendEvent('Matcher', 'close onboarding', buttonType);
    close();
  };

  const handleNext = () => {
    Metrics.ga.sendEvent('Matcher', 'continue onboarding', 'button click');
    next();
  };

  useEffect(() => {
    Metrics.ga.sendEvent('Matcher', 'Onboarding', 'pageview');
  }, []);

  return (
    <div data-test="matcherModal" className="matcher-onboarding">
      <CloseButton
        className="matcher-onboarding--close"
        onClose={() => handleClose('header button')}
      />
      <div className="matcher-onboarding--content">
        <MatcherIcon />
        <h2 className="matcher-onboarding--title">
          {trans('search.matcher.onboarding.title')}
        </h2>
        <p className="matcher-onboarding--description">
          {trans('search.matcher.onboarding.description')}
        </p>
      </div>
      <div className="matcher-onboarding--button-container">
        <Button
          size={'large'}
          fullWidth
          onClick={handleNext}
          className={'matcher-onboarding--button'}
        >
          {trans('search.matcher.onboarding.continue')}
        </Button>
        <Button
          size={'large'}
          fullWidth
          alt
          className={'matcher-onboarding--button'}
          onClick={() => handleClose('main button')}
        >
          {trans('search.matcher.onboarding.close')}
        </Button>
      </div>
    </div>
  );
};

Onboarding.propTypes = {
  next: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default Onboarding;
